import Route from './route.js';
import RouteMarker from '../markers/route-marker.js';

export default class TrailerRoute extends Route {
    constructor(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo) {
        super(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo);
        this.trailerWidthPolyline;

        this._paintTrailerWidthPolyline = () => {
            this._makeRemoveLayerEvent(this.trailerWidthPolyline);
            this.trailerWidthPolyline = new L.featureGroup();
            let width = this.route.coords[0].width;
            let coordsArray = [];
            for (let point of this.route.coords) {
                if (point.width == width) {
                    coordsArray.push([point.lat, point.lon, point.st]);
                }
                else {
                    coordsArray.push([point.lat, point.lon, point.st]);
                    let widthPolyline = this._widthPolyline(coordsArray, width);
                    this.trailerWidthPolyline.addLayer(widthPolyline);
                    coordsArray = [];
                    coordsArray.push([point.lat, point.lon, point.st]);
                    width = point.width;
                }
            }
            if (coordsArray.length > 0) {
                let widthPolyline = this._widthPolyline(coordsArray, width);
                this.trailerWidthPolyline.addLayer(widthPolyline);
            }
            this._makeAddLayerEvent(this.trailerWidthPolyline);
        }
        this._paintTrailerWidthPolyline();
        document.addEventListener('zoomend', this._paintTrailerWidthPolyline);
    };

    _widthPolyline(coordsArray, width) {
        let multiOptions = {
            optionIdxFn: (latLng) => {
                var i;
                if (latLng[2] == 1) {
                    return 0;
                }
                else
                    return 1;
            },
            options: [
                { color: 'red' },
                { color: this.color },
            ]
        };
        return L.multiOptionsPolyline(coordsArray, {
            multiOptions: multiOptions,
            weight: this._getLineWidth(width),
            lineCap: 'round',
            opacity: 0.4,
            interactive: false,
            smoothFactor: 1,
            clickable: false,
        });
    };

    // фунция дублирует функцию из line.js
    _getLineWidth(radiusInMeters) {
        var pointC = this.map.latLngToContainerPoint(this.map.getCenter());
        // add one pixel to x
        var pointX = [pointC.x + 1, pointC.y];
        // convert containerpoints to latlng's
        var latLngC = this.map.containerPointToLatLng(pointC);
        var latLngX = this.map.containerPointToLatLng(pointX);
        // calculate distance between c and x (latitude) - столько метров в 1 пикселе
        var distanceX = latLngC.distanceTo(latLngX);
        // ширина полилинии в пикселях на текущем масштабе карты
        var wght = radiusInMeters / distanceX;
        return wght;
    }
}
